import { Grid } from "@mui/material";
import React from "react";

function SectionThree() {
  const secThreeData = [
    {
      offperc: "80% off",
      domainName: ".co",
      domainDes: "The Domain startups",
      priceBefore: "$4.48/Yr",
      priceAfter: "Instead of 23.28/y=Yr",
      btn_title: "Check Availability",
    },
    {
      offperc: "80% off",
      domainName: ".NET",
      domainDes: "The Domain startups",
      priceBefore: "$4.48/Yr",
      priceAfter: "Instead of 23.28/y=Yr",
      btn_title: "Check Availability",
    },
    {
      offperc: "80% off",
      domainName: ".US",
      domainDes: "The Domain startups",
      priceBefore: "$4.48/Yr",
      priceAfter: "Instead of 23.28/y=Yr",
      btn_title: "Check Availability",
    },
    {
      offperc: "80% off",
      domainName: ".COM",
      domainDes: "The Domain startups",
      priceBefore: "$4.48/Yr",
      priceAfter: "Instead of 23.28/y=Yr",
      btn_title: "Check Availability",
    },
    {
      offperc: "80% off",
      domainName: ".ORG",
      domainDes: "The Domain startups",
      priceBefore: "$4.48/Yr",
      priceAfter: "Instead of 23.28/y=Yr",
      btn_title: "Check Availability",
    },
    {
      offperc: "80% off",
      domainName: ".COM",
      domainDes: "The Domain startups",
      priceBefore: "$4.48/Yr",
      priceAfter: "Instead of 23.28/y=Yr",
      btn_title: "Check Availability",
    },
  ];
  return (
    <div className="third_main_div">
      <Grid container justifyContent="center">
        <Grid item xs={11} sm={10} md={10} lg={10}>
          {/* Grid For headings */}
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={11} lg={6}>
              <h1 className="head_h">Discover A Huge Variety Of Domains</h1>
              <p className="head_p">
                Check domain name availability and secure yours now.
              </p>
            </Grid>
            <Grid item sm={10} lg={4}>
              <div className="tab_btns">
                <span className="tab_span">
                  <button className="btn_one">Popular</button>
                  <button className="btn_Two">Deal</button>
                </span>
              </div>
            </Grid>
          </Grid>
          {/* NESTED GRID FOR SEC 3 CARDS */}
          <div className="seprator"></div>
          <Grid
            container
            sx={{
              justifyContent: {
                xs: "center",
                lg: "space-between",
              },
            }}
          >
            {secThreeData.map((e) => {
              return (
                <Grid item xs={12} lg={3.9}>
                  <div className="sec_three_card">
                    <div className="c_tab">
                      <span className="tab_para">{e.offperc}</span>
                    </div>
                    <div className="with_padding">
                      <h2 className="three_h_1">{e.domainName}</h2>
                      <p className="three_p_1">{e.domainDes}</p>
                      <div className="price_div">
                        <span className="three_blue">{e.priceBefore}</span>
                        <span className="three_pale">{e.priceAfter}</span>
                      </div>

                      <button className="common_btn_three">
                        {e.btn_title}
                      </button>
                    </div>
                  </div>
                </Grid>
              );
            })}
          </Grid>

          {/* NESTED GRID FOR SEC 3 CARDS */}
        </Grid>
      </Grid>
    </div>
  );
}

export default SectionThree;
